"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _reactDayPicker = _interopRequireDefault(require("react-day-picker"));
var _moment = _interopRequireDefault(require("react-day-picker/moment"));
require("moment/min/locales");
var _moment2 = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var DateInputComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(DateInputComponent, _React$Component);
  function DateInputComponent(props) {
    var _this;
    _classCallCheck(this, DateInputComponent);
    _this = _callSuper(this, DateInputComponent, [props]);
    _this.dayClick = _this.dayClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(DateInputComponent, [{
    key: "dayClick",
    value: function dayClick(date) {
      var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (modifiers.disabled) return;
      var _this$props = this.props,
        onDayClick = _this$props.onDayClick,
        validFn = _this$props.validFn;
      onDayClick(date);
      validFn();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        inputRef = _this$props2.inputRef,
        selectedDate = _this$props2.selectedDate,
        hasError = _this$props2.hasError,
        errorMessage = _this$props2.errorMessage,
        country = _this$props2.country,
        intl = _this$props2.intl;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactDayPicker.default, {
        fromMonth: new Date(),
        onDayClick: this.dayClick,
        className: "availability-calendar",
        month: selectedDate,
        localeUtils: _moment.default,
        selectedDays: selectedDate,
        disabledDays: [{
          before: new Date()
        }],
        locale: (0, _get.default)(intl, 'locale', 'en')
      }), /*#__PURE__*/_react.default.createElement("input", {
        ref: function ref(_ref) {
          if ('function' === typeof inputRef) inputRef(_ref);
        },
        type: "hidden",
        readOnly: true,
        "data-value": selectedDate,
        value: selectedDate ? (0, _moment2.default)(selectedDate).format('ll') : ''
      }), hasError && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginBottom: '16px'
        },
        className: "text-danger help-block"
      }, errorMessage));
    }
  }]);
  return DateInputComponent;
}(_react.default.Component);
DateInputComponent.propTypes = {
  inputRef: _propTypes.default.func,
  onDayClick: _propTypes.default.func.isRequired,
  selectedDate: _propTypes.default.instanceOf(Date),
  hasError: _propTypes.default.bool,
  validFn: _propTypes.default.func,
  errorMessage: _propTypes.default.string,
  country: _propTypes.default.string
};
var DateInput = exports.DateInput = (0, _reactIntl.injectIntl)(DateInputComponent);